module.exports = __webpack_public_path__ + "static/media/T-shirt_brown.8481eb88.svg";